
// components
import Header from '../components/header/Header';
import Experience from '../components/experience/Experience';
import Projects from '../components/projects/Projects';
import Skills from '../components/skills/Skills';

const Homepage = () => {
    return (
        <div className="">
            <Header />
            <Experience />
            <Skills />
            <Projects />
        </div>
    )
}

export default Homepage;